module.exports = __webpack_public_path__ + "media/images/center-3752f6a8af24b4cf832fb4f4855caf1c.svg";